// Which created_location the sitting picker stamps on the cart.
//
// `from` on the URL (e.g. from=sitting_recovery on the abandoned-cart reminder)
// wins on both paths. Without it a NEW cart is tagged 'sittings' as before, and
// an EXISTING apptCart keeps whatever it already has (undefined = do not touch).
// Cart#set_created_location normalizes unknown values server-side.
export default function createdLocationForAppointment(from, existingCart) {
  if (from) return from;
  return existingCart ? undefined : 'sittings';
}
